import InfoSvg from '@/../img/info.svg';
import { CITY_MODES } from '@/constants';
import { LOCALSTORAGE_MAP_INFOBOX_EXPAND } from '@/user/user-constants';
import { BinaryRenderer } from '@/widgets/components/binary-renderer';
import flattenDeep from 'lodash/flattenDeep';
import { useState } from 'react';
import { INFO_BOX_SUBTITLES } from '../map-constants';
import {
  Disclaimer,
  DonotShowAgain,
  DotCaption,
  IncludeCitiesNotice,
  ListingCityName,
  PlatformStatsOfListings,
  ShrinkActionButton,
  TotalListings,
} from './listing-summary-parts';
import {
  DashedLine,
  ListingSummaryBtn,
  SummaryWrapper,
} from './listing-summary-styles';

function mapPlatformAndListings(listings) {
  const platforms = flattenDeep(
    listings.map((listing) => listing.onlinePlatforms)
  );
  const uniquePlatforms = {};
  platforms.forEach((p) => {
    if (uniquePlatforms[p] === undefined) {
      uniquePlatforms[p] = 1;
    } else {
      uniquePlatforms[p]++;
    }
  });
  return uniquePlatforms;
}

function SummaryContent(props) {
  const platformListings = mapPlatformAndListings(props.listings);
  const uniquePlatforms = Object.keys(platformListings);
  const { platformToDisplayConfig, displayUnlicensedPropertiesSeparately } =
    props;

  // const currentStrProperties = props.listings.filter((p) => p.active);
  // const identifiedListings = props.listings.filter((p) => !!p.apn);
  const shortTermRentals = props.listings.filter((p) => p.shortTermRental);
  const licensedIdentifiedSTRListings = shortTermRentals.filter(
    (p) => !!p.apn && !!p.strLicense
  );
  const unlicensedIdentifiedSTRListings = shortTermRentals.filter(
    (p) => !!p.apn && !p.strLicense
  );
  const unidentifiedSTRLiveListings = shortTermRentals.filter(
    (p) => !p.apn && p.live
  );
  const nonSTRListings = props.listings.filter(
    (p) => !p.shortTermRental || (!p.APN && !p.live)
  );

  const { currentCity, currentCityPlaceNS, customerConfigIncludesCities } =
    props;

  return (
    <SummaryWrapper>
      <ShrinkActionButton onClick={props.onClick} />
      <ListingCityName
        city={props.cityDisplayName}
        cityMode={props.cityMode}
        subtitle={INFO_BOX_SUBTITLES[props.cityMode]}
      />
      <IncludeCitiesNotice
        currentPlaceNSFields={currentCityPlaceNS}
        currentPlace={currentCity}
        customerConfigIncludesCities={customerConfigIncludesCities}
      />
      <PlatformStatsOfListings
        uniquePlatforms={uniquePlatforms}
        platformListings={platformListings}
        platformToDisplayConfig={platformToDisplayConfig}
      />
      <TotalListings totalListings={props.listings.length} />
      <DashedLine />
      <DotCaption
        licensedIdentifiedCount={licensedIdentifiedSTRListings.length}
        unlicensedIdentifiedCount={unlicensedIdentifiedSTRListings.length}
        activeCount={unidentifiedSTRLiveListings.length}
        inactiveCount={nonSTRListings.length}
        displayUnlicensedPropertiesSeparately={
          displayUnlicensedPropertiesSeparately
        }
        labels={
          props.isTot
            ? {
                licensed: 'TOT Certificated STR Properties',
                unlicensed: 'TOT Uncertificated STR Properties',
              }
            : null
        }
      />
      <Disclaimer cityMode={props.cityMode} />
      <BinaryRenderer checkpoint={props.cityMode !== CITY_MODES.customer}>
        <DonotShowAgain />
      </BinaryRenderer>
    </SummaryWrapper>
  );
}

export function ListingSummary(props) {
  const DEFAULT_EXPAND_STATUS =
    props.cityMode !== CITY_MODES.customer &&
    JSON.parse(localStorage.getItem(LOCALSTORAGE_MAP_INFOBOX_EXPAND));

  const [expanded, setExpanded] = useState(DEFAULT_EXPAND_STATUS);

  return (
    <ListingSummaryBtn
      aria-label="View listing statistics"
      className="mapboxgl-ctrl"
      expanded={expanded}
      onClick={() => (expanded ? null : setExpanded(!expanded))}
    >
      <BinaryRenderer
        checkpoint={expanded}
        fallback={<InfoSvg aria-label="Information" />}
      >
        <SummaryContent {...props} onClick={() => setExpanded(!expanded)} />
      </BinaryRenderer>
    </ListingSummaryBtn>
  );
}
